/* flow */
import WebAPI from './WebAPI';
import config from '../../config';

const WebAPIClient = new WebAPI(config.agentGatewayUrl, 'v1');

export default WebAPIClient;
